import { toast } from "react-toastify";
import IntlUtils from "services/intl/utils";
import AlertPoliciesApi from "./api";
import AlertPoliciesTypes from "./types";

export class AlertPoliciesActioner {
  static setAlertPolicies(data) {
    return {
      type: AlertPoliciesTypes.SET_ALERT_POLICIES,
      data,
    };
  }

  static setAlertPoliciesInitialized = (initialized) => {
    return {
      type: AlertPoliciesTypes.SET_ALERT_POLICIES_INITIALIZED,
      initialized,
    };
  };

  static getAlertPolicies = () => {
    return (dispatch, getState) => {
      const { contract } = getState().Contract;
      const { id } = contract;

      if (getState().AlertFactory.alertPolicies.initialized) {
        dispatch(AlertPoliciesActioner.setAlertPoliciesInitialized(false));
      }

      return AlertPoliciesApi.getAlertPolicies({ contract_id: id }).then(
        (res) => {
          dispatch(AlertPoliciesActioner.setAlertPolicies(res));
        }
      );
    };
  };

  static manageOutputs = (data) => {
    return (dispatch) => {
      const intl = IntlUtils.getIntlInstance();

      return AlertPoliciesApi.manageAlertPoliciesOutputs(data)
        .then((res) => {
          let msg = intl.messages["toast.success.manageAlertOutputsSuccess"];

          toast(msg, {
            position: toast.POSITION.BOTTOM_RIGHT,
            type: toast.TYPE.SUCCESS,
          });

          dispatch(AlertPoliciesActioner.getAlertPolicies());
          return res;
        })
        .catch((err) => {
          let msg = intl.messages["toast.errors.errorOccuredContactSupport"];
          if (err.status === 403) {
            msg = intl.formatMessage({
              id: "toast.errors.alerts.manageOutputs",
            });
          }

          toast(msg, {
            position: toast.POSITION.BOTTOM_RIGHT,
            type: toast.TYPE.ERROR,
          });
          return Promise.reject(err);
        });
    };
  };
}
